import { Pipe, PipeTransform } from '@angular/core';
import { formatDate, registerLocaleData } from '@angular/common';
import localeEsSV from '@angular/common/locales/es-SV';

registerLocaleData(localeEsSV, 'es-SV');

/**
 * Igual que el pipe `date` de Angular (mismos formatos y zona horaria), pero
 * siempre en español de El Salvador: "14 oct 2026, 4:09 p. m." en vez de
 * "Oct 14, 2026, 4:09:04 PM". No cambia el idioma global de la app (eso
 * también alteraría el formato de moneda del `currency`).
 */
@Pipe({ name: 'esDate', standalone: true })
export class EsDatePipe implements PipeTransform {
  transform(value: string | number | Date | null | undefined, format = 'mediumDate', timezone?: string): string | null {
    if (value === null || value === undefined || value === '') return null;
    try {
      return formatDate(value, format, 'es-SV', timezone);
    } catch {
      return null;
    }
  }
}
